import LayoutComponent from 'src/components/user/layout-component';
import NotificationsContainer from 'src/containers/user/notifications-container/notifications-container';

function NotificationPage() {
  return (
    <LayoutComponent showLogo={true}>
      <div className="bg-zinc-50 pt-52 mobile:pt-20 px-8">
        <NotificationsContainer />
        <div className="h-32"></div>
      </div>
    </LayoutComponent>
  );
}

export default NotificationPage